// Реестр маршрутов приложения. См. docs/domain.md §2.
// Строки не хардкодятся в коде приложения — только через ROUTES.

export const ROUTES = {
  onboarding: '/onboarding',
  home: '/',

  compat: '/compat',
  compatTarget: '/compat/target',
  compatResult: (id: string) => `/compat/result/${id}`,

  links: '/links',
  person: (linkId: string) => `/links/${linkId}`,
  inbox: '/links/inbox',

  stats: '/stats',

  profile: '/profile',
  profilePrivacy: '/profile/privacy',
  profileHistory: '/profile/history',

  natal: '/natal',
  /** Единственный экран ввода данных карты: и своей, и чужой (правка основателя №8). */
  natalData: '/natal/data',
  natalResult: '/natal/result',
  natalHouses: '/natal/houses',
  /** Точки и углы — глубокий разбор карты. */
  natalDeep: '/natal/points',
  /** @deprecated Ввод данных чужой карты переехал на `natalData`; адрес живёт редиректом. */
  natalOther: '/natal/other',
  /** Результат чужой карты — считается `POST /natal/preview` и не сохраняется нигде. */
  natalOtherResult: '/natal/other/result',

  bowl: '/bowl',
  subscription: '/subscription',
  /** «Спасибо, подписки пока нет» — вместо оплаты на MVP. */
  subscriptionThanks: '/subscription/thanks',
  /** Гейт подписки на канал: экран без выхода, пока доступ закрыт (docs/domain.md §2). */
  gate: '/gate',
} as const
